(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chatgpt-v55-collection-description"] && !Shopify.designMode) return;
  try {
    /* CHATGPT VERSION 5.6 — START: measured one-and-a-half-line rich-text disclosure */
  if (!customElements.get('cg56-collection-description')) {
    customElements.define('cg56-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.ready) return;
        this.content = this.querySelector('[data-cg56-content]');
        this.preview = this.querySelector('[data-cg56-preview]');
        this.toggle = this.querySelector('[data-cg56-toggle]');
        if (!this.content || !this.preview || !this.toggle) return;
        this.ready = true;
        this.expanded = false;
        this.width = Math.round(this.getBoundingClientRect().width);
        this.onToggle = () => {
          this.expanded = !this.expanded;
          this.showState();
          this.toggle.focus({ preventScroll: true });
          if (!this.expanded) {
            const rect = this.toggle.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight) {
              this.toggle.scrollIntoView({ block: 'center', behavior: 'instant' });
            }
          }
        };
        this.toggle.addEventListener('click', this.onToggle);
        this.onResize = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (this.isConnected) this.measure();
          });
        };
        this.observer = new ResizeObserver(entries => {
          const width = Math.round(entries[0].contentRect.width);
          if (width !== this.width) {
            this.width = width;
            this.onResize();
          }
        });
        this.observer.observe(this);
        this.measure();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { if (this.isConnected) this.onResize(); });
        }
      }
      textNodes(root) {
        const nodes = [];
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.textContent.trim() && !node.parentElement.closest('script, style, template, [hidden], [data-cg56-toggle]')) {
            nodes.push(node);
          }
        }
        return nodes;
      }
      lines(root, includeButton = false) {
        const rects = [];
        const range = document.createRange();
        for (const node of this.textNodes(root)) {
          range.selectNodeContents(node);
          for (const rect of range.getClientRects()) {
            if (rect.width > 0 && rect.height > 0) rects.push(rect);
          }
        }
        if (includeButton) {
          range.selectNodeContents(this.toggle);
          for (const rect of range.getClientRects()) {
            if (rect.width > 0 && rect.height > 0) rects.push(rect);
          }
        }
        const lines = [];
        rects.sort((a, b) => a.top - b.top);
        for (const rect of rects) {
          const line = lines.find(item => Math.abs(item.top - rect.top) < Math.min(item.height, rect.height) * 0.55);
          if (line) {
            line.left = Math.min(line.left, rect.left);
            line.right = Math.max(line.right, rect.right);
          } else {
            lines.push({ top: rect.top, height: rect.height, left: rect.left, right: rect.right });
          }
        }
        return lines;
      }
      /* CHATGPT VERSION 5.6 — START: stop around halfway across the second line */
      fitsPreview(root, includeButton = false) {
        const lines = this.lines(root, includeButton);
        if (lines.length < 2) return true;
        if (lines.length > 2) return false;
        const block = this.tail(root);
        const style = getComputedStyle(block);
        const width = block.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const secondLineFraction = 0.5;
        return lines[1].right - lines[1].left <= width * secondLineFraction + 1;
      }
      /* CHATGPT VERSION 5.6 — END: stop around halfway across the second line */
      parkButton() {
        if (this.spacer) this.spacer.remove();
        this.toggle.hidden = true;
        this.append(this.toggle);
      }
      tail(root) {
        const nodes = this.textNodes(root);
        let element = nodes.length ? nodes[nodes.length - 1].parentElement : root.lastElementChild;
        while (element && element !== root) {
          const display = getComputedStyle(element).display;
          if (/^(block|list-item|table-cell|flow-root)$/.test(display) && !element.matches('a, button')) return element;
          element = element.parentElement;
        }
        return root;
      }
      placeButton(root) {
        if (this.spacer) this.spacer.remove();
        /* CHATGPT VERSION 5.6 — START: ellipsis belongs to the description, before the link */
        if (root === this.preview) {
          const nodes = this.textNodes(root);
          const last = nodes[nodes.length - 1];
          if (last) last.textContent = last.textContent.replace(/[.…]+\s*$/u, '');
        }
        this.spacer = document.createTextNode(root === this.preview ? '...\u00a0' : '\u00a0');
        /* CHATGPT VERSION 5.6 — END: ellipsis belongs to the description, before the link */
        this.tail(root).append(this.spacer, this.toggle);
        this.toggle.hidden = false;
      }
      candidate(point) {
        this.parkButton();
        const range = document.createRange();
        range.selectNodeContents(this.content);
        range.setEnd(point.node, point.offset);
        this.preview.replaceChildren(range.cloneContents());
        this.preview.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        this.placeButton(this.preview);
      }
      measure() {
        const focused = document.activeElement === this.toggle;
        this.parkButton();
        this.content.hidden = false;
        this.preview.hidden = true;
        /* CHATGPT VERSION 5.7 — START: show two full lines; collapse only longer descriptions at the current width */
        const fullDescriptionLines = this.lines(this.content).length;
        this.canCollapse = this.getBoundingClientRect().width > 0 && fullDescriptionLines > 2;
        /* CHATGPT VERSION 5.7 — END: show two full lines; collapse only longer descriptions at the current width */
        if (!this.canCollapse) {
          this.preview.replaceChildren();
          this.expanded = false;
          this.showState();
          return;
        }
        const points = [];
        for (const node of this.textNodes(this.content)) {
          for (const word of node.textContent.matchAll(/\S+/gu)) {
            points.push({ node, offset: word.index + word[0].length });
          }
        }
        if (!points.length) {
          this.canCollapse = false;
          this.showState();
          return;
        }
        this.toggle.textContent = this.toggle.dataset.more;
        this.content.hidden = true;
        this.preview.hidden = false;
        let low = 0;
        let high = points.length - 1;
        let best = -1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          this.candidate(points[middle]);
          if (this.fitsPreview(this.preview, true)) {
            best = middle;
            low = middle + 1;
          } else {
            high = middle - 1;
          }
        }
        this.candidate(best >= 0 ? points[best] : { node: points[0].node, offset: 0 });
        this.showState();
        if (focused && !this.toggle.hidden) this.toggle.focus({ preventScroll: true });
      }
      showState() {
        this.parkButton();
        const collapsed = this.canCollapse && !this.expanded;
        this.preview.hidden = !collapsed;
        this.content.hidden = collapsed;
        this.toggle.setAttribute('aria-expanded', String(!collapsed));
        if (this.canCollapse) {
          this.toggle.textContent = collapsed ? this.toggle.dataset.more : this.toggle.dataset.less;
          this.placeButton(collapsed ? this.preview : this.content);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        this.ready = false;
      }
    });
  }
  /* CHATGPT VERSION 5.6 — END: measured one-and-a-half-line rich-text disclosure */
  } catch(e) { console.error(e); }
})();

})();
